import { BillingExplorerCSVColumnItem } from "@/store/resource-explorer/selectors/current-resource-explorer/csv/possible-columns/utils/types";
import { CsvSelectedPossibleColumns } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/csv-v2/dialog/utils/types";

export const sortColumnsBySelectedState = (
  data: BillingExplorerCSVColumnItem[],
  selectedColumns: CsvSelectedPossibleColumns,
): BillingExplorerCSVColumnItem[] => {
  return [...data].sort((a, b) => {
    const aSelected = !!selectedColumns?.[a.keyValue];
    const bSelected = !!selectedColumns?.[b.keyValue];
    if (aSelected === bSelected) return 0;
    return aSelected ? -1 : 1;
  });
};
